import { Periods, convertPeriodToRange } from '@/models/StandardReport'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)

/**
 * 設定値に従い全体orデイリーレポート取得用のクエリを生成する関数を返す。
 */
const buildReportQuery = ({
  period,
  calendarRange,
  selectedInsertionOrderIds,
  selectedBillingPeriodIds,
  insertionOrders,
}) => {
  const convertedPeriod =
    period === Periods.CALENDAR ? calendarRange : convertPeriodToRange(period)

  // ioBudgetをrangeでフィルターかける
  const filterdSelectedBillingPeriodIds =
    selectedBillingPeriodIds && period !== Periods.TOTAL
      ? selectedBillingPeriodIds.filter(id => {
          return insertionOrders.some(io => {
            return io.billingPeriods.some(bp => {
              return (
                bp.id === id &&
                // 期間のチェック
                (dayjs(bp.startTime).isSameOrAfter(
                  dayjs(convertedPeriod.startDate),
                ) ||
                  dayjs(bp.endTime).isSameOrAfter(
                    dayjs(convertedPeriod.startDate),
                  )) &&
                (dayjs(bp.startTime).isSameOrBefore(
                  dayjs(convertedPeriod.endDate),
                ) ||
                  dayjs(bp.endTime).isSameOrBefore(
                    dayjs(convertedPeriod.endDate),
                  ))
              )
            })
          })
        })
      : selectedBillingPeriodIds

  return dimensionType => ({
    insertionOrder: {
      ids: selectedInsertionOrderIds,
    },
    ioBudget: {
      ids: filterdSelectedBillingPeriodIds,
    },
    dimensionType,
    period: convertedPeriod,
    format: 'json',
  })
}

export default buildReportQuery
